<section class="student-parent-hub-section py-5 my-4 bg-light">
  <div class="container px-lg-5">
    <!-- Header -->
    <div class="text-center mb-5">
      <span class="hub-tag text-uppercase fw-bold text-orange">Connecting Community</span>
      <h2 class="display-6 fw-bold text-success mt-2">Student & Parent Hub</h2>
      <div class="header-divider mx-auto mt-3"></div>
    </div>

    <!-- Cards Grid: Three Column Layout Side by Side -->
    <div class="row g-4 justify-content-center">
      <!-- 1. Parents Meet Card -->
      <div class="col-12 col-md-6 col-lg-4">
        <div class="hub-card rounded-0 overflow-hidden shadow-sm bg-white transition-all border border-light h-100">
          <div class="card-media-wrapper position-relative">
            <img src="assets/img/home/parents_meet_img5.jpg" alt="Parents Gathering" class="w-100 h-100 hub-img">
            <div class="media-overlay d-flex align-items-center justify-content-center">
              <span class="badge bg-success rounded-pill px-3 py-2 text-uppercase fs-7 fw-bold shadow-sm">
                <i class="fa-solid fa-people-group me-1"></i> Meeting Photo
              </span>
            </div>
          </div>
          <!-- Orange Caption Bar -->
          <div class="bg-orange py-3 text-center text-white fw-bold card-caption text-uppercase fs-5">
            Parents Meet
          </div>
        </div>
      </div>

      <!-- 2. Parents View Card -->
      <div class="col-12 col-md-6 col-lg-4">
        <div class="hub-card rounded-0 overflow-hidden shadow-sm bg-white transition-all border border-light">
          <div class="card-media-wrapper position-relative" (click)="toggleParentVideo()">
            <!-- HTML5 Video Player without poster -->
            <video #parentVideo src="assets/mp4/Parents-1.mp4" class="w-100 h-100 hub-video" preload="auto"
              (timeupdate)="onParentTimeUpdate()" (ended)="onParentEnded()" playsinline></video>

            <!-- Center Play Button (Large Transparent White Triangle Overlay) -->
            <div class="center-play-overlay d-flex align-items-center justify-content-center" *ngIf="!parentPlaying">
              <svg viewBox="0 0 100 100" class="center-play-svg">
                <polygon points="35,25 35,75 75,50" fill="rgba(255, 255, 255, 0.95)"></polygon>
              </svg>
            </div>

            <!-- Custom Controls Bar (Dark strip at the bottom) -->
            <div class="custom-controls-bar d-flex align-items-center gap-3 px-3 py-2 text-white"
              (click)="$event.stopPropagation()">
              <!-- Play / Pause / Restart Toggle Button -->
              <button class="control-btn p-0 border-0 bg-transparent text-white" (click)="toggleParentVideo()">
                <i class="fa-solid fa-play" *ngIf="!parentPlaying && parentElapsed === '00:00'"></i>
                <i class="fa-solid fa-pause" *ngIf="parentPlaying"></i>
                <i class="fa-solid fa-rotate-right" *ngIf="!parentPlaying && parentElapsed !== '00:00'"></i>
              </button>

              <!-- Elapsed Time -->
              <span class="time-display">{{ parentElapsed }}</span>

              <!-- Seek Slider/Progress Track -->
              <div class="progress-track flex-grow-1">
                <div class="progress-bar-fill" [style.width.%]="parentProgress"></div>
              </div>

              <!-- Total Duration -->
              <span class="time-display">{{ parentDuration }}</span>

              <!-- Volume Control -->
              <button class="control-btn p-0 border-0 bg-transparent text-white">
                <i class="fa-solid fa-volume-high"></i>
              </button>

              <!-- Fullscreen Button -->
              <button class="control-btn p-0 border-0 bg-transparent text-white"
                (click)="toggleParentFullscreen($event)">
                <i class="fa-solid fa-expand"></i>
              </button>
            </div>
          </div>
          <!-- Orange Caption Bar -->
          <div class="bg-orange py-3 text-center text-white fw-bold card-caption text-uppercase fs-5">
            Parents View
          </div>
        </div>
      </div>

      <!-- 3. Students View Card -->
      <div class="col-12 col-md-6 col-lg-4">
        <div class="hub-card rounded-0 overflow-hidden shadow-sm bg-white transition-all border border-light">
          <div class="card-media-wrapper position-relative" (click)="toggleStudentVideo()">
            <!-- HTML5 Video Player without poster -->
            <video #studentVideo src="assets/mp4/Student-1.mp4" class="w-100 h-100 hub-video" preload="auto"
              (timeupdate)="onStudentTimeUpdate()" (ended)="onStudentEnded()" playsinline></video>

            <!-- Center Play Button (Large Transparent White Triangle Overlay) -->
            <div class="center-play-overlay d-flex align-items-center justify-content-center" *ngIf="!studentPlaying">
              <svg viewBox="0 0 100 100" class="center-play-svg">
                <polygon points="35,25 35,75 75,50" fill="rgba(255, 255, 255, 0.95)"></polygon>
              </svg>
            </div>

            <!-- Custom Controls Bar (Dark strip at the bottom) -->
            <div class="custom-controls-bar d-flex align-items-center gap-3 px-3 py-2 text-white"
              (click)="$event.stopPropagation()">
              <!-- Play / Pause / Restart Toggle Button -->
              <button class="control-btn p-0 border-0 bg-transparent text-white" (click)="toggleStudentVideo()">
                <i class="fa-solid fa-play" *ngIf="!studentPlaying && studentElapsed === '00:00'"></i>
                <i class="fa-solid fa-pause" *ngIf="studentPlaying"></i>
                <i class="fa-solid fa-rotate-right" *ngIf="!studentPlaying && studentElapsed !== '00:00'"></i>
              </button>

              <!-- Elapsed Time -->
              <span class="time-display">{{ studentElapsed }}</span>

              <!-- Seek Slider/Progress Track -->
              <div class="progress-track flex-grow-1">
                <div class="progress-bar-fill" [style.width.%]="studentProgress"></div>
              </div>

              <!-- Total Duration -->
              <span class="time-display">{{ studentDuration }}</span>

              <!-- Volume Control -->
              <button class="control-btn p-0 border-0 bg-transparent text-white">
                <i class="fa-solid fa-volume-high"></i>
              </button>

              <!-- Fullscreen Button -->
              <button class="control-btn p-0 border-0 bg-transparent text-white"
                (click)="toggleStudentFullscreen($event)">
                <i class="fa-solid fa-expand"></i>
              </button>
            </div>
          </div>
          <!-- Orange Caption Bar -->
          <div class="bg-orange py-3 text-center text-white fw-bold card-caption text-uppercase fs-5">
            Students View
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation / Next Button Row -->
    <!-- <div class="text-end mt-4 px-2">
      <a href="javascript:void(0)"
        class="next-btn d-inline-flex align-items-center gap-2 fw-bold text-success transition-all text-decoration-none">
        <span>NEXT</span>
        <i class="fa-solid fa-arrow-right-long text-orange"></i>
      </a>
    </div> -->
    <!-- Affiliations & Accreditations (Moved from footer) -->
    <div class="row justify-content-center mt-3 pt-3 border-top border-2 border-white">
      <div class="col-12 text-center">
        <img src="assets/img/logo/logos.png" alt="Accreditations & Affiliations" class="hub-accreditations-img">
      </div>
    </div>
  </div>
</section>